<ion-header class="main-fixed-header" [scrollHide]="headerScrollConfig" [scrollContent]="resultSearchContent"
    style="top: -100px;">
</ion-header>

<ion-content fullscreen #resultSearchContent>
    <div class="search-box">
        <div class="gradient-layer"></div>
        <div class="main-content">
            <ion-row>
                <ion-col class="flex">
                    <button ion-button clear class="title-text title-text-medium" (click)="onBack()">
                        <ion-icon name="arrow-back" class="padding-right"></ion-icon>
                        <strong>
                            {{ 'GLOBAL_CANCEL' | translate }}
                        </strong>
                    </button>
                </ion-col>
                <ion-col class="flex-end">
                    <button ion-button icon-only clear color="light" (click)="showLogin()"
                        attr.aria-label="{{ 'GLOBAL_MYSPORT' | translate }}" padding-right>
                        <span [style.background-image]="'url(' + profileImage() + ')'" class="user-image-m"
                            *ngIf="isLoged()" circle></span>
                        <span [style.background-image]="'url(/assets/imgs/default-image-32@1x.png)'"
                            class="user-image-m" *ngIf="!isLoged()" circle></span>
                    </button>
                </ion-col>
            </ion-row>
            <ion-row>
                <ion-col col-12 text-center>
                    <span class="title-text title-text-large">
                        {{ event?.eventName }}
                    </span>
                </ion-col>
            </ion-row>
            <ion-row class="flex-auto">
                <ion-col col-12>
                    <ion-row class="custom-search-field">
                        <ion-col col-1>
                            <div class="vertical-center-outer">
                                <div class="vertical-center-inner padding-top-medium" text-center>
                                    <ion-icon color="white" name="calendar" class="sportart-icon-big"></ion-icon>
                                </div>
                            </div>
                        </ion-col>
                        <ion-col col-11 class="custom-search-field-container">
                            <ion-select [(ngModel)]="searchModel.dt" placeholder="{{ searchModel.dt }}"
                                (ionChange)="onDateChanged()" cancelText="{{ 'GLOBAL_CANCEL' | translate }}"
                                okText="{{ 'GLOBAL_OK' | translate }}" class="title-text-medium"
                                *ngIf="eventDates.length > 0">
                                <!-- the date of event -->
                                <ion-option *ngFor="let date of eventDates" [value]="date?.value">
                                    {{ date?.value }}
                                </ion-option>
                            </ion-select>
                        </ion-col>
                    </ion-row>
                </ion-col>
            </ion-row>
            <ion-row class="flex-auto">
                <ion-col col-12>
                    <ion-row class="custom-search-field">
                        <ion-col col-1>
                            <div class="vertical-center-outer">
                                <div class="vertical-center-inner padding-top-medium" text-center>
                                    <ion-icon color="white" name="resize" class="sportart-icon-big"></ion-icon>
                                </div>
                            </div>
                        </ion-col>
                        <ion-col col-11 class="custom-search-field-container">
                            <ion-select [(ngModel)]="searchModel.dist" placeholder="{{ searchModel.dist }}"
                                (ionChange)="onDistChanged()" cancelText="{{ 'GLOBAL_CANCEL' | translate }}"
                                okText="{{ 'GLOBAL_OK' | translate }}" class="title-text-medium"
                                *ngIf="eventDistances.length > 0">
                                <!-- the first strecke of event -->
                                <ion-option *ngFor="let distance of eventDistances" [value]="distance?.value">
                                    <!-- the strecke options -->
                                    {{ distance?.value }}
                                </ion-option>
                            </ion-select>
                        </ion-col>
                    </ion-row>
                </ion-col>
            </ion-row>
            <ion-row class="flex-auto">
                <ion-col col-12>
                    <ion-row class="custom-search-field">
                        <ion-col col-1>
                            <div class="vertical-center-outer">
                                <div class="vertical-center-inner padding-top-medium" text-center>
                                    <ion-icon color="white" name="pricetag" class="sportart-icon-big"></ion-icon>
                                </div>
                            </div>
                        </ion-col>
                        <ion-col col-11 class="custom-search-field-container">
                            <ion-select [(ngModel)]="searchModel.t" placeholder="{{ searchModel.t }}"
                                (ionChange)="onTypeChanged()" cancelText="{{ 'GLOBAL_CANCEL' | translate }}"
                                okText="{{ 'GLOBAL_OK' | translate }}" class="title-text-medium"
                                *ngIf="eventTypes.length > 0">
                                <!-- the first type of event -->
                                <ion-option *ngFor="let type of eventTypes" [value]="type?.value">
                                    {{ type?.value }}
                                </ion-option>
                            </ion-select>
                        </ion-col>
                    </ion-row>
                </ion-col>
            </ion-row>
            <ion-row class="flex-auto">
                <ion-col col-12>
                    <ion-item no-padding class="custom-search-field no-border custom-search-text">
                        <ion-icon name="person" item-start color="gray"></ion-icon>
                        <ion-input type="text" [(ngModel)]="searchModel.sw" (ionChange)="onInputChange()"
                            placeholder="{{ 'RESULT_SEARCH_ATHLETES NAME' | translate }}" value="">
                        </ion-input>
                    </ion-item>
                </ion-col>
            </ion-row>
            <ion-row>
                <ion-col col-12 text-center>
                    <button ion-button margin-top margin-bottom icon-start color="light" outline (click)="onSearch()">
                        <ion-icon name="search"></ion-icon>
                        {{ 'GLOBAL_SEARCH' | translate}}
                    </button>
                </ion-col>
            </ion-row>
        </div>
    </div>
    <div class="result-list">
        <ion-list>
            <result-ranglist-list-item *ngFor="let item of list" [result]="item"></result-ranglist-list-item>
            <ion-infinite-scroll #infiniteScroll (ionInfinite)="loadNextPage($event)" *ngIf="list.length%25===0 && list.length>0">
                <ion-infinite-scroll-content loadingSpinner="bubbles"
                    loadingText="{{'GLOBAL_SEARCH_LOADING_MORE' | translate}}">
                </ion-infinite-scroll-content>
            </ion-infinite-scroll>
        </ion-list>
    </div>
</ion-content>